import { API } from "aws-amplify";
import { listBuildings } from "~/graphql/queries";
import { GRAPHQLFilters, LoaderData } from "~/types";
import { getGraphqlFilters } from "~/utils";
import * as APITypes from "~/API";

export const getBuildingList = async ({
  ownerID,
  ownerType,
  propertyID,
  includeDeleted = "exclude",
}: {
  ownerID?: string;
  ownerType?: APITypes.OwnerType;
  propertyID?: string;
  includeDeleted?: "all" | "exclude" | "only";
}): Promise<LoaderData<APITypes.Building[]>> => {
  const filters: GRAPHQLFilters = getGraphqlFilters({
    propertyID,
    ownerID,
    ownerType,
  });

  // Add _deleted filter based on includeDeleted parameter
  if (includeDeleted === "exclude") {
    filters._deleted = { ne: true };
  } else if (includeDeleted === "only") {
    filters._deleted = { eq: true };
  }
  // If includeDeleted === "all", don't add any _deleted filter

  let items: APITypes.Building[] = [];
  let nextToken: string | null | undefined = undefined;
  try {
    do {
      const response = (await API.graphql({
        query: listBuildings,
        variables: {
          filter: filters,
          nextToken,
        },
      })) as {
        data?: APITypes.ListBuildingsQuery;
      };

      const buildings =
        response.data?.listBuildings?.items?.filter(
          (item): item is APITypes.Building => item !== null
        ) ?? [];
      items.push(...buildings);
      nextToken = response.data?.listBuildings?.nextToken;
    } while (nextToken);

    return {
      success: true,
      data: items,
    };
  } catch (error) {
    console.error("Error fetching building list:", error);
    return {
      success: false,
      data: [],
      error,
    };
  }
};
